import { FC } from "react";
import { NavigateFunction } from "react-router-dom";
import { BinSelectedInfo } from "../../../../../redux/slices/grainTracker/grainTrackerTypes";

type FirstMenuLocationDetailsParams = {
  navigate: NavigateFunction;
  t: (arg0: string) => string;
  resetSingleLocationState: () => void;
  isBinSelected: boolean;
  locationSelectedDetails: any;
  selectedBin: {
    values: undefined | BinSelectedInfo;
    loading: boolean;
    error: string;
  };
  resetBin: () => void;
};

const FirstMenuLocationDetails: FC<FirstMenuLocationDetailsParams> = ({
  navigate,
  resetSingleLocationState,
  t,
  isBinSelected,
  locationSelectedDetails,
  selectedBin,
  resetBin,
}) => {
  return (
    <div className="first-menu-location-details">
      <span
        role="none"
        className="site-option-button-back site-underline-location"
        onClick={() => {
          navigate("/locations");
          resetSingleLocationState();
        }}
      >{`${t("Common_options.sites")}`}</span>

      <span className="site-option-button-back ml-1 mr-1">{">"}</span>
      {isBinSelected ? (
        <span
          className="site-option-button-back site-underline-location"
          role="none"
          onClick={() => {
            resetBin();
          }}
        >
          {locationSelectedDetails?.name}
        </span>
      ) : (
        <span className="site-option-button-back " role="none">
          {locationSelectedDetails?.name}
        </span>
      )}
      {isBinSelected ? (
        <>
          <span className="site-option-button-back ml-1 mr-1">{">"}</span>
          <span className="site-option-button-back ">
            {selectedBin?.values?.name}
          </span>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default FirstMenuLocationDetails;
